import { reactModule } from './utils/react';

const modules = [
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'ms-news-carousel-block',
    loader: () => import('./modules/ms-news-carousel-block')
  },
  {
    name: 'ms-animator',
    loader: () => import('./modules/ms-animator')
  },
  {
    name: 'ms-notification',
    loader: () => import('./react-modules/ms-notification'),
    render: reactModule
  },
  {
    name: 'application-selector',
    loader: () => import('./react-modules/application-selector'),
    render: reactModule
  },
  {
    name: 'ms-breadcrumb',
    loader: () => import('./react-modules/ms-breadcrumb'),
    render: reactModule
  },
  {
    name: 'ms-site-alert-banner',
    loader: () => import('./react-modules/ms-site-alert-banner'),
    render: reactModule
  },
  {
    name: 'ms-header',
    loader: () => import('./react-modules/ms-header'),
    render: reactModule
  },
  {
    name: 'ms-footer-sections',
    loader: () => import('./react-modules/ms-footer-sections'),
    render: reactModule
  },
  {
    name: 'ms-disclaimer-modal',
    loader: () => import('./modules/ms-disclaimer-modal')
  },
  {
    name: 'ms-latest-webinars-and-events-block',
    loader: () => import('./react-modules/ms-latest-webinars-and-events-block'),
    render: reactModule
  },
  {
    name: 'ms-webinar-results-block',
    loader: () => import('./react-modules/ms-webinar-results-block'),
    render: reactModule
  },
  {
    name: 'ms-counter',
    loader: () => import('./modules/ms-counter')
  },
  {
    name: 'ms-news-results-block',
    loader: () => import('./react-modules/ms-news-results-block'),
    render: reactModule
  },
  {
    name: 'ms-blog-results-block',
    loader: () => import('./react-modules/ms-blog-results-block'),
    render: reactModule
  },
  {
    name: 'ms-blog-detail-block',
    loader: () => import('./react-modules/ms-blog-detail-block'),
    render: reactModule
  },
  {
    name: 'ms-lead-space-block',
    loader: () => import('./react-modules/ms-lead-space-block'),
    render: reactModule
  },
  {
    name: 'ms-blog-lead-space-block',
    loader: () => import('./react-modules/ms-blog-lead-space-block'),
    render: reactModule
  },
  {
    name: 'ms-cobrands-login',
    loader: () => import('./react-modules/ms-cobrands-login'),
    render: reactModule
  },
  {
    name: 'ms-connect-w-crump-block',
    loader: () => import('./react-modules/ms-connect-w-crump-block'),
    render: reactModule
  },
  {
    name: 'ms-sign-up-block',
    loader: () => import('./react-modules/ms-sign-up-block'),
    render: reactModule
  },
  {
    name: 'ms-search-page-filters-and-results-block',
    loader: () =>
      import('./react-modules/ms-search-page-filters-and-results-block'),
    render: reactModule
  },
  {
    name: 'ms-hanleigh-gap-coverage-calculator',
    loader: () =>
      import('./react-modules/ms-hanleigh-gap-coverage-calculator'),
    render: reactModule
  },
  {
    name: 'ms-hanleigh-contact-us',
    loader: () =>
      import('./react-modules/ms-hanleigh-contact-us'),
    render: reactModule
  }, 
  {
    name: 'ms-hanleigh-request-quote',
    loader: () =>
      import('./react-modules/ms-hanleigh-request-a-quote'),
    render: reactModule
  },
  {
    name: 'ms-connect-w-tlis',
    loader: () => import('./react-modules/ms-connect-w-tlis'),
    render: reactModule
  },
  {
    name: 'ms-digitized-questionnaire',
    loader: () => import('./react-modules/ms-digitized-questionnaire'),
    render: reactModule
  }
];

export default [...modules];
